import React,{ createRef, useRef } from 'react';
import '../css/Home.css';
import * as THREE from 'three';
import GLOBE from 'vanta/dist/vanta.globe.min.js';
import TopBar from './TopBar.tsx';
import { useMediaQuery } from '@mui/system';

class Home extends React.Component { 
    
    vantaRef = createRef<HTMLDivElement>();
    vanataEffect:any = null;
    componentDidMount() {
        if (this.vantaRef.current) {
            this.vanataEffect = GLOBE({
                el: this.vantaRef.current,
                mouseControls: false,
                touchControls: true,
                gyroControls: false,
                Height: 500.00,
                Width: 500.00,
                scale: 1.00,
                scaleMobile: 2.00,
                color: 0xce8d8,
                color2: 0x3fc6ff,
                size: 1.68,
                backgroundColor: 0x000000,
                THREE: THREE, // THREE.jsのインポートを指定
            });
        }
    }
    componentWillUnmount(): void {
        if(this.vanataEffect){
            this.vanataEffect.destroy();
        }
    }
    render() {
        return (
            <div ref={this.vantaRef}
                style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: -1
                }}>
                <TopBar />
                <div className='background'>
                    <div className='intro'>
                        <h1>Saito Engineering Laboratory</h1>
                        <h2>Web Developer, H.S</h2>
                    </div>
                </div>
            </div>
        );
  }
}
export default Home